<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { ElButton, ElDialog, ElForm, ElFormItem, ElInput, ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import PaymentAPI from '@/api/payment'
import QRCode from 'qrcode'

// 添加store和router
const store = useStore()
const router = useRouter()

// 获取登录状态
const isLoggedIn = computed(() => {
  return store.getters.token || store.getters.isPersonalLogin
})

// 响应式屏幕宽度
const screenWidth = ref(1200)

// 更新屏幕宽度
const updateScreenWidth = () => {
  if (typeof window !== 'undefined') {
    screenWidth.value = window.innerWidth
  }
}

onMounted(() => {
  getList()
  updateScreenWidth()
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', updateScreenWidth)
  }
})

onUnmounted(() => {
  // 清理窗口大小监听器
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', updateScreenWidth)
  }

  // 清理支付轮询定时器
  stopPaymentPolling()
})
const products = ref([
  {
    id: 0,
    cover: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MM6F3?wid=400&hei=400&fmt=jpeg&qlt=95&.v=1645138486317',
    title: '抛光布',
    price: 'RMB 248',
    tag: '',
    provider: ''
  },
  {
    id: 1,
    cover: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/HQ7F2?wid=400&hei=400&fmt=jpeg&qlt=95&.v=1645138486317',
    title: 'Satechi 磁力卡包支架',
    price: 'RMB 398',
    tag: 'Apple 独家提供',
    provider: 'Apple'
  },
  {
    id: 2,
    cover: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MM6G3?wid=400&hei=400&fmt=jpeg&qlt=95&.v=1645138486317',
    title: 'Nimble Champ 10k 移动电源 - 深青色',
    price: 'RMB 548',
    tag: 'Apple 独家提供',
    provider: 'Apple'
  },
  {
    id: 3,
    cover: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/ML763?wid=400&hei=400&fmt=jpeg&qlt=95&.v=1645138486317',
    title: '46 毫米金色链式表带',
    price: 'RMB 329',
    tag: '',
    provider: ''
  },
  {
    id: 4,
    cover: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MN653?wid=400&hei=400&fmt=jpeg&qlt=95&.v=1645138486317',
    title: 'iPhone 16 Pro 硅胶保护壳',
    price: 'RMB 1098',
    tag: '',
    provider: ''
  },
  {
    id: 5,
    cover: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MME73?wid=400&hei=400&fmt=jpeg&qlt=95&.v=1645138486317',
    title: 'AirPods (第三代)',
    price: 'RMB 1399',
    tag: '',
    provider: ''
  }
])
const pageSize = 3
const currentPage = ref(0)

// 响应式页面大小 - 手机端每页显示1个，桌面端每页显示3个
const responsivePageSize = computed(() => {
  return screenWidth.value <= 768 ? 1 : pageSize
})

const pageCount = computed(() => Math.ceil(products.value.length / responsivePageSize.value))
const pagedProducts = computed(() => {
  const start = currentPage.value * responsivePageSize.value
  return products.value.slice(start, start + responsivePageSize.value)
})

function prev () {
  if (currentPage.value > 0) currentPage.value--
}

function next () {
  if (currentPage.value < pageCount.value - 1) currentPage.value++
}

const books = ref([
  {
    id: 6,
    cover: 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/MDV54?wid=532&hei=582&fmt=png-alpha&.v=WEFsc0twRGdlZk8rRDdNQUNPTTJLQUhqc0NvK2RZTVd5TWVhUDFuQlo0M1V0OFRXMXBKeWJVdGh0b28vdkJvVm1mMG52WEZxZ3VRV1dLL1pja1dtTUE',
    title: '49 毫米黑色钛金属米兰尼斯表带',
    author: 'M',
    price: 'RMB 1,779',
    colors: ['#2c2c2c', '#4a4a4a']
  },
  {
    id: 7,
    cover: 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/MDT54ref?wid=532&hei=582&fmt=png-alpha&.v=b3M5R09kYnh0WTExY0pHUFdsdVB6Vkxrd3NRTzUwSGh2QVAzV3JWV0JLZmh6QUZBNlVUR2RYcjYyR2hPZE5xc3FZQlh5Q2tFR2UyL3pvZEQyUGo1b0E',
    title: '46 毫米配灰色 Nike 回环式运动表带',
    author: '',
    price: 'RMB 379',
    colors: ['#8b7355', '#b8a082', '#6b6b6b', '#4a4a4a', '#2c2c2c']
  },
  {
    id: 8,
    cover: 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/MXMH3?wid=532&hei=582&fmt=png-alpha&.v=VnV6dmp1aEs0aWlFNG5wNldrRStEQUhqc0NvK2RZTVd5TWVhUDFuQlo0MzQ3RjF5QkFGbTlwZVExQU9xNlhrYjRNYzRQKzNFNmRnM2d0ekFYZ0tFV2c',
    title: '46 毫米牡丹色编织单圈表带',
    author: '6 号',
    price: 'RMB 779',
    colors: ['#e91e63', '#ff9800', '#ffeb3b', '#4a4a4a', '#2c2c2c']
  },
  {
    id: 9,
    cover: 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/MXKF3ref?wid=532&hei=582&fmt=png-alpha&.v=QnVJL1dxRnlQb1didk5Da01Rc24vbExrd3NRTzUwSGh2QVAzV3JWV0JLZXhNM2ptYzhXYXBPZTRtcUROcFZjcXlSY2tZL1g5YUVocHJETmVEakNEM0E',
    title: '49 毫米天然钛金属链式表带',
    author: 'M',
    price: 'RMB 2,299',
    colors: ['#d4af37', '#b8860b']
  },
  {
    id: 10,
    cover: 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/MXU33?wid=532&hei=582&fmt=png-alpha&.v=WnVPRUx5UFJnRnhNSURad3dzdFMzd0hqc0NvK2RZTVd5TWVhUDFuQlo0MmkyWHAwZTYyQTdPcFlCVm1MQzg5dHN2T2JIZmJTMHJMYWE4UEVOeFdMSUE',
    title: '46 毫米星光色运动表带',
    author: '',
    price: 'RMB 329',
    colors: ['#f5f5dc', '#e6e6fa', '#d3d3d3']
  },
  {
    id: 11,
    cover: 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/MDL04ref?wid=532&hei=582&fmt=png-alpha&.v=akxWbU5jTWwyL1ZXTUZqd1lLSGdVRkxrd3NRTzUwSGh2QVAzV3JWV0JLZmh6QUZBNlVUR2RYcjYyR2hPZE5xc2VXYXBSOTUrNzF3bTdHaWFwcks3Z3c',
    title: '46 毫米粉色编织表带',
    author: '小号',
    price: 'RMB 679',
    colors: ['#ffc0cb', '#ff69b4', '#da70d6']
  }
])
const bookPageSize = 3
const currentBookPage = ref(0)

// 表带响应式页面大小
const responsiveBookPageSize = computed(() => {
  return screenWidth.value <= 768 ? 1 : bookPageSize
})

const bookPageCount = computed(() => Math.ceil(books.value.length / responsiveBookPageSize.value))
const pagedBooks = computed(() => {
  const start = currentBookPage.value * responsiveBookPageSize.value
  return books.value.slice(start, start + responsiveBookPageSize.value)
})

function prevBook () {
  if (currentBookPage.value > 0) currentBookPage.value--
}

function nextBook () {
  if (currentBookPage.value < bookPageCount.value - 1) currentBookPage.value++
}

// 购买弹窗相关
const purchaseDialogVisible = ref(false)
const paymentDialogVisible = ref(false)
const orderStatusDialogVisible = ref(false)
const selectedProduct = ref(null)
const paymentLoading = ref(false)
const orderForm = ref({
  name: '',
  phone: '',
  address: ''
})

// 购物车相关
const cartVisible = ref(false)
const cartItems = ref([])

// 计算购物车总数量
const cartItemCount = computed(() => {
  return cartItems.value.reduce((total, item) => total + item.quantity, 0)
})

// 格式化价格显示
const formatPrice = (price) => {
  if (typeof price === 'string') {
    // 如果已经是格式化的字符串（如 "RMB 248"），直接返回
    if (price.includes('RMB') || price.includes('￥')) {
      return price
    }
    // 如果是纯数字字符串，添加RMB前缀
    const numPrice = parseFloat(price)
    return isNaN(numPrice) ? price : `RMB ${numPrice}`
  } else if (typeof price === 'number') {
    // 如果是数字，添加RMB前缀
    return `RMB ${price}`
  }
  return price || 'RMB 0'
}

// 计算购物车总价
const cartTotalPrice = computed(() => {
  return cartItems.value.reduce((total, item) => {
    let price = 0

    // 处理不同类型的价格数据
    if (typeof item.price === 'string') {
      // 如果是字符串，提取数字部分
      const priceMatch = item.price.match(/[\d.]+/)
      price = priceMatch ? parseFloat(priceMatch[0]) : 0
    } else if (typeof item.price === 'number') {
      // 如果是数字，直接使用
      price = item.price
    } else {
      // 其他情况默认为0
      price = 0
    }

    return total + (price * item.quantity)
  }, 0)
})

// 订单信息
const orderInfo = ref({
  orderNumber: '',
  status: '已支付',
  createTime: '',
  paymentTime: '',
  estimatedDelivery: ''
})

// 订单列表
const orderList = ref([])

// 加入购物车事件
const addToCart = (product) => {
  const existingItem = cartItems.value.find(item => item.id === product.id)

  if (existingItem) {
    // existingItem.quantity += 1
    // ElMessage.success(`已增加 ${product.title} 的数量`)
    ElMessage.success('已加入购物车')
  } else {
    cartItems.value.push({
      ...product,
      quantity: 1
    })
    ElMessage.success(`${product.title} 已加入购物车`)
  }
}

// 显示购物车
const showCart = () => {
  cartVisible.value = true
}

// 关闭购物车
const closeCart = () => {
  cartVisible.value = false
}

// 移除购物车商品
const removeFromCart = (productId) => {
  const index = cartItems.value.findIndex(item => item.id === productId)
  if (index > -1) {
    const removedItem = cartItems.value.splice(index, 1)[0]
    ElMessage.success(`已移除 ${removedItem.title}`)
  }
}

// 更新购物车商品数量
const updateCartItemQuantity = (productId, quantity) => {
  const item = cartItems.value.find(item => item.id === productId)
  if (item) {
    if (quantity <= 0) {
      removeFromCart(productId)
    } else {
      item.quantity = quantity
    }
  }
}

// 清空购物车
const clearCart = () => {
  cartItems.value = []
  ElMessage.success('购物车已清空')
}

// 立即购买（从购物车）
const buyNow = () => {
  // 检查登录状态
  if (!isLoggedIn.value) {
    ElMessage.warning('请先登录')
    router.push('/personal-login')
    return
  }

  if (cartItems.value.length === 0) {
    ElMessage.warning('购物车为空')
    return
  }

  // 将购物车中的商品信息设置为选中商品
  selectedProduct.value = {
    title: `购物车商品 (${cartItems.value.length}件)`,
    price: `RMB ${cartTotalPrice.value.toFixed(2)}`,
    cover: cartItems.value[0].cover // 使用第一个商品的图片
  }

  cartVisible.value = false
  purchaseDialogVisible.value = true
}

// 购买按钮点击事件（原来的）
const handlePurchase = (product) => {
  selectedProduct.value = product
  purchaseDialogVisible.value = true
}

// 确认购买 - 调用支付API（修改为使用购物车商品ID）
const confirmPurchase = async () => {
  // 检查登录状态
  if (!isLoggedIn.value) {
    ElMessage.warning('请先登录')
    router.push('/personal-login')
    return
  }

  if (!orderForm.value.name || !orderForm.value.phone || !orderForm.value.address) {
    ElMessage.warning('请填写完整信息')
    return
  }

  try {
    paymentLoading.value = true

    // 获取购物车商品ID列表，如果购物车为空则使用默认值
    const productIds = cartItems.value.map(item => item.id)

    // 调用支付API创建订单
    const response = await PaymentAPI.createWxOrder({
      productsIds: productIds,
      buyBy: orderForm.value.name,
      phone: orderForm.value.phone,
      address: orderForm.value.address
    })

    if (response && response.data) {
      // 保存订单号用于轮询查询
      currentOrderCode.value = response.data.orderCode

      // 使用API返回的codeUrl数据生成二维码
      const qrCodeDataURL = await generateQRCode(response.data.codeUrl)
      if (qrCodeDataURL) {
        qrCodeUrl.value = qrCodeDataURL
        paymentDialogVisible.value = true

        // 开始轮询支付状态
        startPaymentPolling()

        ElMessage.success('订单创建成功，请扫码支付')
        purchaseDialogVisible.value = false
      } else {
        ElMessage.error('生成支付二维码失败，请重试')
      }
    } else {
      ElMessage.error('创建订单失败，请重试')
    }
  } catch (error) {
    console.error('创建订单失败:', error)
    ElMessage.error('创建订单失败: ' + (error.message || '网络错误'))
  } finally {
    paymentLoading.value = false
  }
}

const getList = async () => {
  const response = await PaymentAPI.queryroducts()
  console.log('获取商品列表:', response.data)

  products.value = response.data.slice(6)
  books.value = response.data.slice(0, 6)
  console.log('获取表带列表:', books.value)
  console.log('获取商品列表:', products.value)
  // 模拟获取订单列表
  // return orderList.value
}

// 关闭弹窗
const closePurchaseDialog = () => {
  purchaseDialogVisible.value = false
  orderForm.value = {
    name: '',
    phone: '',
    address: ''
  }
}

const closePaymentDialog = () => {
  // 停止支付状态轮询
  stopPaymentPolling()

  paymentDialogVisible.value = false
  qrCodeUrl.value = '' // 清除二维码
  selectedProduct.value = null
  currentOrderCode.value = '' // 清除订单号
}

const closeOrderStatusDialog = () => {
  orderStatusDialogVisible.value = false
  // 重置表单
  orderForm.value = {
    name: '',
    phone: '',
    address: ''
  }
  qrCodeUrl.value = '' // 清除二维码
  selectedProduct.value = null
}

// 生成订单号
const generateOrderNumber = () => {
  const timestamp = Date.now()
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0')
  return `YQ${timestamp}${random}`
}

// 支付完成处理（手动点击）
const handlePaymentComplete = () => {
  // 停止轮询
  stopPaymentPolling()

  const now = new Date()
  const deliveryDate = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000) // 7天后

  const newOrderNumber = currentOrderCode.value || generateOrderNumber()

  orderInfo.value = {
    orderNumber: newOrderNumber,
    status: '已支付',
    createTime: now.toLocaleString('zh-CN'),
    paymentTime: now.toLocaleString('zh-CN'),
    estimatedDelivery: deliveryDate.toLocaleDateString('zh-CN')
  }

  // 将新订单添加到订单列表的开头
  const newOrder = {
    id: Date.now().toString(),
    orderNumber: newOrderNumber,
    productTitle: selectedProduct.value?.title || '',
    productImg: selectedProduct.value?.cover || '',
    price: selectedProduct.value?.price || '',
    status: '已支付',
    createTime: now.toLocaleString('zh-CN'),
    paymentTime: now.toLocaleString('zh-CN'),
    estimatedDelivery: deliveryDate.toLocaleString('zh-CN'),
    customerName: orderForm.value.name,
    customerPhone: orderForm.value.phone,
    customerAddress: orderForm.value.address
  }

  orderList.value.unshift(newOrder)

  // 支付成功后清空购物车
  if (cartItems.value.length > 0) {
    clearCart()
  }

  paymentDialogVisible.value = false
  orderStatusDialogVisible.value = true

  ElMessage.success('支付成功！')
}

// 显示订单状态
const showOrderStatus = () => {
  // 检查登录状态
  if (!isLoggedIn.value) {
    ElMessage.warning('请先登录')
    router.push('/personal-login')
    return
  }
  getOrderList()

  orderStatusDialogVisible.value = true
}

const getOrderList = async () => {
  try {
    const params = {

      paging: {

        pageSize: 100,
        activePage: 1
      }
    }
    const response = await PaymentAPI.queryOrderList(params)
    console.log('获取订单列表:', response.data)
    orderList.value = response.data || []
  } catch (error) {
    console.error('获取订单列表失败:', error)
    ElMessage.error('获取订单列表失败，请重试')
  }
}

// 生成二维码（这里将通过API返回）
const qrCodeUrl = ref('')

// 支付轮询相关
const currentOrderCode = ref('')
const paymentPollingTimer = ref(null)
const pollingInterval = 3000 // 3秒轮询一次

// 生成二维码函数
const generateQRCode = async (data) => {
  try {
    const qrCodeDataURL = await QRCode.toDataURL(data, {
      width: 256,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    })
    return qrCodeDataURL
  } catch (error) {
    console.error('生成二维码失败:', error)
    ElMessage.error('生成二维码失败')
    return null
  }
}

// 开始轮询支付状态
const startPaymentPolling = () => {
  if (paymentPollingTimer.value) {
    clearInterval(paymentPollingTimer.value)
  }

  paymentPollingTimer.value = setInterval(async () => {
    await checkPaymentStatus()
  }, pollingInterval)

  console.log('开始轮询支付状态，订单号:', currentOrderCode.value)
}

// 停止轮询支付状态
const stopPaymentPolling = () => {
  if (paymentPollingTimer.value) {
    clearInterval(paymentPollingTimer.value)
    paymentPollingTimer.value = null
    console.log('停止轮询支付状态')
  }
}

// 检查支付状态
const checkPaymentStatus = async () => {
  if (!currentOrderCode.value) {
    console.warn('缺少订单号，停止轮询')
    stopPaymentPolling()
    return
  }

  try {
    console.log(`正在查询订单 ${currentOrderCode.value} 的支付状态...`)
    const response = await PaymentAPI.queryWxPaymentStatus(currentOrderCode.value)
    console.log('支付状态查询结果:', response)

    if (response && response.data) {
      const paymentStatus = response.data.status || response.data.paymentStatus
      console.log('当前支付状态:', paymentStatus)

      if (paymentStatus === 'SUCCESS' || paymentStatus === '已支付' || paymentStatus === 'PAID') {
        // 支付成功
        console.log('支付成功，停止轮询')
        stopPaymentPolling()
        handlePaymentSuccess(response.data)
      } else if (paymentStatus === 'FAILED' || paymentStatus === '支付失败') {
        // 支付失败
        console.log('支付失败，停止轮询')
        stopPaymentPolling()
        handlePaymentFailure()
      } else {
        console.log('支付状态为待支付，继续轮询...')
      }
      // 其他状态（如PENDING、待支付等）继续轮询
    }
  } catch (error) {
    console.error('查询支付状态失败:', error)
    // 网络错误或API错误，可以考虑重试几次后停止轮询
  }
}

// 处理支付成功
const handlePaymentSuccess = async (paymentData) => {
  // const now = new Date()
  // const deliveryDate = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000) // 7天后
  //
  // orderInfo.value = {
  //   orderNumber: currentOrderCode.value,
  //   status: '已支付',
  //   createTime: now.toLocaleString('zh-CN'),
  //   paymentTime: now.toLocaleString('zh-CN'),
  //   estimatedDelivery: deliveryDate.toLocaleDateString('zh-CN')
  // }
  //
  // // 将新订单添加到订单列表的开头
  // const newOrder = {
  //   id: Date.now().toString(),
  //   orderNumber: currentOrderCode.value,
  //   productTitle: selectedProduct.value?.title || '',
  //   productImg: selectedProduct.value?.cover || '',
  //   price: selectedProduct.value?.price || '',
  //   status: '已支付',
  //   createTime: now.toLocaleString('zh-CN'),
  //   paymentTime: now.toLocaleString('zh-CN'),
  //   estimatedDelivery: deliveryDate.toLocaleString('zh-CN'),
  //   customerName: orderForm.value.name,
  //   customerPhone: orderForm.value.phone,
  //   customerAddress: orderForm.value.address
  // }
  //
  // orderList.value.unshift(newOrder)

  getOrderList()

  // 支付成功后清空购物车
  if (cartItems.value.length > 0) {
    clearCart()
  }

  paymentDialogVisible.value = false
  orderStatusDialogVisible.value = true

  ElMessage.success('支付成功！')
}

// 处理支付失败
const handlePaymentFailure = () => {
  ElMessage.error('支付失败，请重试')
  // 可以选择关闭支付弹窗或让用户重新尝试
}

// 触摸滑动支持
const touchStart = ref({
  x: 0,
  y: 0
})
const touchEnd = ref({
  x: 0,
  y: 0
})

const handleTouchStart = (e) => {
  touchStart.value = {
    x: e.touches[0].clientX,
    y: e.touches[0].clientY
  }
}

const handleTouchEnd = (e) => {
  touchEnd.value = {
    x: e.changedTouches[0].clientX,
    y: e.changedTouches[0].clientY
  }

  const deltaX = touchStart.value.x - touchEnd.value.x
  const deltaY = Math.abs(touchStart.value.y - touchEnd.value.y)

  // 只有当水平滑动距离大于垂直滑动距离且滑动距离超过50px时才触发
  if (Math.abs(deltaX) > deltaY && Math.abs(deltaX) > 50) {
    if (deltaX > 0) {
      // 向左滑动，下一页
      next()
    } else {
      // 向右滑动，上一页
      prev()
    }
  }
}

// 书籍轮播的触摸事件
const handleBookTouchStart = (e) => {
  touchStart.value = {
    x: e.touches[0].clientX,
    y: e.touches[0].clientY
  }
}

const handleBookTouchEnd = (e) => {
  touchEnd.value = {
    x: e.changedTouches[0].clientX,
    y: e.changedTouches[0].clientY
  }

  const deltaX = touchStart.value.x - touchEnd.value.x
  const deltaY = Math.abs(touchStart.value.y - touchEnd.value.y)

  if (Math.abs(deltaX) > deltaY && Math.abs(deltaX) > 50) {
    if (deltaX > 0) {
      nextBook()
    } else {
      prevBook()
    }
  }
}

// 获取订单状态样式
const getStatusClass = (status) => {
  switch (status) {
    case '已支付':
      return 'status-paid'
    case '待发货':
      return 'status-pending'
    case '已发货':
      return 'status-shipped'
    case '已完成':
      return 'status-completed'
    case '已取消':
      return 'status-cancelled'
    default:
      return 'status-default'
  }
}
</script>

<template>
  <div class="shopping-page">
    <div class="shopping-carousel">
      <h2 class="carousel-title">趣选好物</h2>
      <div class="carousel-content">
        <button :disabled="currentPage === 0" class="carousel-arrow left" @click="prev">&#8592;</button>
        <div class="carousel-wrapper" @touchend="handleTouchEnd" @touchstart="handleTouchStart">
          <div :style="{ transform: `translateX(-${currentPage * 100}%)` }" class="carousel-cards carousel-animate">
            <div v-for="pageIdx in pageCount" :key="pageIdx" class="carousel-page">
              <div v-for="(item, idx) in products.slice((pageIdx-1) * responsivePageSize, pageIdx * responsivePageSize)"
                   :key="idx" class="carousel-card active">
                <img :src="item.cover" class="card-img" />
                <!--              <div class="card-tag" v-if="item.tag">-->
                <!--                <span class="provider">{{ item.provider }}</span> <span class="tag">{{ item.tag.replace(item.provider, '') }}</span>-->
                <!--              </div>-->
                <div class="card-title">{{ item.title }}</div>
                <div class="card-price">{{ formatPrice(item.price) }}</div>
                <el-button
                  class="purchase-btn"
                  size="small"
                  type="primary"
                  @click="addToCart(item)">
                  加入购物车
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <button :disabled="currentPage === pageCount - 1" class="carousel-arrow right" @click="next">&#8594;</button>
      </div>
      <div class="carousel-dots">
        <span v-for="idx in pageCount" :key="idx" :class="{ active: idx - 1 === currentPage }" class="dot"></span>
      </div>
    </div>

    <!-- 新增Apple Watch表带轮播 -->
    <div class="shopping-carousel book-carousel">
      <h2 class="carousel-title">表带</h2>
      <div class="carousel-content">
        <button :disabled="currentBookPage === 0" class="carousel-arrow left" @click="prevBook">&#8592;</button>
        <div class="carousel-wrapper" @touchend="handleBookTouchEnd" @touchstart="handleBookTouchStart">
          <div :style="{ transform: `translateX(-${currentBookPage * 100}%)` }" class="carousel-cards carousel-animate">
            <div v-for="pageIdx in bookPageCount" :key="pageIdx" class="carousel-page">
              <div
                v-for="(item, idx) in books.slice((pageIdx-1) * responsiveBookPageSize, pageIdx * responsiveBookPageSize)"
                :key="idx" class="carousel-card active">
                <img :src="item.cover" class="card-img" />
                <div v-if="item.author === 'Apple 独家提供'" class="card-tag">
                  <span class="provider">Apple</span> <span class="tag">独家提供</span>
                </div>
                <div class="card-title">{{ item.title }}</div>
                <div class="card-author">{{ item.author }}</div>
                <div v-if="item.colors && item.colors.length > 0" class="card-colors">
                <span v-for="color in item.colors" :key="color" :style="{ backgroundColor: color }"
                      class="color-dot"></span>
                  <span v-if="item.colors.length > 5" class="color-more">+</span>
                </div>
                <div class="card-price">{{ formatPrice(item.price) }}</div>
                <el-button
                  class="purchase-btn"
                  size="small"
                  type="primary"
                  @click="addToCart(item)">
                  加入购物车
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <button :disabled="currentBookPage === bookPageCount - 1" class="carousel-arrow right" @click="nextBook">&#8594;
        </button>
      </div>
      <div class="carousel-dots">
        <span v-for="idx in bookPageCount" :key="idx" :class="{ active: idx - 1 === currentBookPage }"
              class="dot"></span>
      </div>
    </div>

    <!-- 购买信息弹窗 -->
    <el-dialog
      v-model="purchaseDialogVisible"
      :class="{ 'mobile-dialog': screenWidth <= 768 }"
      :fullscreen="false"
      :modal-class="screenWidth <= 768 ? 'mobile-modal' : ''"
      :top="screenWidth <= 768 ? '5vh' : '15vh'"
      :width="screenWidth <= 768 ? '95%' : '500px'"
      title="购买商品"
      @close="closePurchaseDialog">
      <div class="purchase-dialog">
        <div class="product-info">
          <!--          <img :src="selectedProduct?.cover" class="dialog-product-img" />-->
          <div class="product-details">
            <h3>{{ selectedProduct?.title }}</h3>
            <p class="dialog-price">{{ selectedProduct?.price }}</p>
          </div>
        </div>

        <el-form :model="orderForm" class="order-form" label-width="80px">
          <el-form-item label="联系人" required>
            <el-input v-model="orderForm.name" placeholder="请输入联系人姓名" />
          </el-form-item>
          <el-form-item label="电话" required>
            <el-input v-model="orderForm.phone" placeholder="请输入联系电话" />
          </el-form-item>
          <el-form-item label="收货地址" required>
            <el-input
              v-model="orderForm.address"
              :rows="3"
              placeholder="请输入详细收货地址"
              type="textarea" />
          </el-form-item>
        </el-form>
      </div>

      <template #footer>
        <el-button @click="closePurchaseDialog">取消</el-button>
        <el-button :loading="paymentLoading" type="primary" @click="confirmPurchase">
          {{ paymentLoading ? '创建订单中...' : '确认购买' }}
        </el-button>
      </template>
    </el-dialog>

    <!-- 支付二维码弹窗 -->
    <el-dialog
      v-model="paymentDialogVisible"
      :class="{ 'mobile-dialog': screenWidth <= 768 }"
      :fullscreen="false"
      :modal-class="screenWidth <= 768 ? 'mobile-modal' : ''"
      :top="screenWidth <= 768 ? '10vh' : '15vh'"
      :width="screenWidth <= 768 ? '95%' : '400px'"
      title="扫码支付"
      @close="closePaymentDialog">
      <div class="payment-dialog">
        <div class="payment-info">
          <h3>{{ selectedProduct?.title }}</h3>
          <p class="payment-price">{{ selectedProduct?.price }}</p>
        </div>

        <div class="qr-code-container">
          <div v-if="paymentLoading" class="loading-container">
            <i class="el-icon-loading"></i>
            <p>正在生成支付二维码...</p>
          </div>
          <div v-else-if="qrCodeUrl" class="qr-code-wrapper">
            <img :src="qrCodeUrl" alt="支付二维码" class="qr-code" />
            <p class="qr-tip">请使用微信或支付宝扫码支付</p>

            <!-- 轮询状态指示器 -->
            <div v-if="paymentPollingTimer" class="polling-status">
              <i class="el-icon-loading"></i>
              <span>正在检测支付状态,请勿关闭窗口...</span>
            </div>
          </div>
          <div v-else class="qr-error">
            <p>二维码生成失败，请重试</p>
          </div>
        </div>
      </div>

<!--            <template #footer>-->
<!--              <el-button @click="closePaymentDialog">取消支付</el-button>-->
<!--              <el-button :disabled="!qrCodeUrl || paymentLoading" type="success" @click="handlePaymentComplete">支付完成-->
<!--              </el-button>-->
<!--            </template>-->
    </el-dialog>

    <!-- 订单状态弹窗 -->
    <el-dialog
      v-model="orderStatusDialogVisible"
      :class="{ 'mobile-dialog': screenWidth <= 768 }"
      :fullscreen="false"
      :modal-class="screenWidth <= 768 ? 'mobile-modal' : ''"
      :top="screenWidth <= 768 ? '5vh' : '10vh'"
      :width="screenWidth <= 768 ? '95%' : '800px'"
      title="我的订单"
      @close="closeOrderStatusDialog">
      <div class="order-list-dialog">
        <div v-if="orderList.length === 0" class="empty-orders">
          <i class="el-icon-document"></i>
          <p>暂无订单记录</p>
        </div>
        <div v-else class="order-list">
          <div
            v-for="order in orderList"
            :key="order.id"
            class="order-item">
            <div class="order-header">
              <div class="order-number">订单号：{{ order.orderCode }}</div>
              <div :class="getStatusClass(order.status)" class="order-status">
                {{ order.status }}
              </div>
              <div v-if="order.payStatus==='PAID'" style="color:#20cc43;font-weight: bold">已支付</div>
              <div v-else style="color: red;font-weight: bold">未支付</div>
            </div>

            <div class="order-content" >
              <div class="product-info" v-for="i in order.productsList" :key="i.id">
                <img :src="i.cover" class="product-img" />
                <div class="product-details">
                  <h4>{{ i.title }}</h4>
                  <p class="price">{{ i.price }} RMB</p>
                </div>
              </div>

              <div class="order-details">
                <div class="detail-row">
                  <span class="label">下单时间：</span>
                  <span class="value">{{ order.createdAt }}</span>
                </div>
<!--                <div class="detail-row">-->
<!--                  <span class="label">支付时间：</span>-->
<!--                  <span class="value">{{ order.paymentTime }}</span>-->
<!--                </div>-->
                <div class="detail-row">
                  <span class="label">收货人：</span>
                  <span class="value">{{ order.buyBy }} {{ order.phone }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">收货地址：</span>
                  <span class="value">{{ order.address }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <el-button type="primary" @click="closeOrderStatusDialog">关闭</el-button>
      </template>
    </el-dialog>

    <!-- 右侧浮动订单按钮 -->
    <el-affix :offset="80" position="right">
      <div class="floating-order-btn" @click="showOrderStatus">
        <span>订单</span>
      </div>
    </el-affix>

    <!-- 右侧浮动购物车按钮 -->
    <el-affix :offset="150" position="right">
      <div class="  floating-cart-btn2" @click="showCart">
        <span>购物车</span>
        <span v-if="cartItemCount > 0" class="cart-badge">{{ cartItemCount }}</span>
      </div>
    </el-affix>

    <!-- 购物车弹窗 -->
    <el-dialog
      v-model="cartVisible"
      :class="{ 'mobile-dialog': screenWidth <= 768 }"
      :fullscreen="false"
      :modal-class="screenWidth <= 768 ? 'mobile-modal' : ''"
      :top="screenWidth <= 768 ? '5vh' : '10vh'"
      :width="screenWidth <= 768 ? '95%' : '600px'"
      title="购物车"
      @close="closeCart">
      <div class="cart-dialog">
        <div v-if="cartItems.length === 0" class="empty-cart">
          <i class="el-icon-shopping-cart-2"></i>
          <p>购物车为空</p>
          <p class="empty-tip">快去挑选喜欢的商品吧～</p>
        </div>
        <div v-else class="cart-items">
          <div v-for="item in cartItems" :key="item.id" class="cart-item">
            <img :src="item.cover" class="cart-item-img" />
            <div class="cart-item-details">
              <h4>{{ item.title }}</h4>
              <p class="cart-item-price">{{ formatPrice(item.price) }}</p>
              <div class="quantity-controls">
                <el-button
                  :disabled="item.quantity <= 1"
                  size="small"
                  @click="updateCartItemQuantity(item.id, item.quantity - 1)">
                  -
                </el-button>
                <span class="quantity">{{ item.quantity }}</span>
                <el-button
                  disabled size="small"
                  @click="updateCartItemQuantity(item.id, item.quantity + 1)">
                  +
                </el-button>
              </div>
            </div>
            <el-button
              size="small"
              text
              type="danger"
              @click="removeFromCart(item.id)">
              删除
            </el-button>
          </div>

          <div class="cart-summary">
            <div class="total-price">
              总价：<span class="price-amount">RMB {{ cartTotalPrice.toFixed(2) }}</span>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="cart-footer">
          <el-button v-if="cartItems.length > 0" @click="clearCart">清空购物车</el-button>
          <el-button
            v-if="cartItems.length > 0"
            type="primary"
            @click="buyNow">
            立即购买
          </el-button>
          <el-button v-else @click="closeCart">关闭</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.shopping-page {
  min-height: 100vh;
}

.shopping-carousel {
  background: #fafafc;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 60px;

  // 手机端适配
  @media (max-width: 768px) {
    padding-bottom: 40px;
  }

  .carousel-title {
    font-size: 40px;
    font-weight: bold;
    margin: 40px 0 24px 0;
    letter-spacing: 2px;
    text-align: center;
    color: #000;

    // 手机端适配
    @media (max-width: 768px) {
      font-size: 28px;
      margin: 24px 0 16px 0;
      letter-spacing: 1px;
    }
  }

  .carousel-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1400px;
    border-radius: 18px;
    position: relative;

    // 手机端适配
    @media (max-width: 768px) {
      max-width: 100%;
      padding: 0;
    }

    .carousel-arrow {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      border: none;
      background: #dedee1;
      color: #555;
      font-size: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin: 0 24px;
      transition: background 0.2s;

      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }

      // 手机端隐藏翻页按钮
      @media (max-width: 768px) {
        display: none;
      }
    }

    .carousel-wrapper {
      overflow: hidden;
      width: 100%;
      max-width: 1120px;

      // 手机端适配
      @media (max-width: 768px) {
        max-width: 100%;
      }
    }

    .carousel-cards {
      display: flex;
      transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .carousel-page {
      display: flex;
      gap: 32px;
      min-width: 100%;
      justify-content: center;

      // 手机端适配 - 单个卡片居中显示
      @media (max-width: 768px) {
        gap: 0;
        padding: 0;
        justify-content: center;
      }
    }

    .carousel-card {
      width: 340px;
      height: 370px;
      background: #fff;
      border-radius: 18px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 32px 16px 24px 16px;
      transition: box-shadow 0.2s, transform 0.2s;
      transform: scale(0.95);
      opacity: 1;

      // 手机端适配 - 卡片独占一行
      @media (max-width: 768px) {
        width: 85%;
        max-width: 320px;
        margin: 0 auto;
        padding: 24px 16px 20px 16px;
        height: auto;
        min-height: 350px;
        transform: scale(1);
      }
    }

    .card-img {
      width: 180px;
      height: 180px;
      object-fit: contain;
      margin-bottom: 24px;

      // 手机端适配
      @media (max-width: 768px) {
        width: 140px;
        height: 140px;
        margin-bottom: 16px;
      }
    }

    .card-tag {
      color: #e67c23;
      font-size: 14px;
      margin-bottom: 8px;

      .provider {
        font-weight: bold;
      }
    }

    .card-title {
      font-size: 18px;
      font-weight: 500;
      text-align: center;
      margin-bottom: 16px;

      // 手机端适配
      @media (max-width: 768px) {
        font-size: 16px;
        margin-bottom: 12px;
        line-height: 1.3;
      }
    }

    .card-price {
      font-size: 16px;
      color: #888;
      margin-top: 8px;

      // 手机端适配
      @media (max-width: 768px) {
        font-size: 15px;
        margin-top: 6px;
      }
    }

    .card-colors {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-bottom: 8px;

      .color-dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 1px solid #e0e0e0;
      }

      .color-more {
        font-size: 12px;
        color: #666;
        margin-left: 2px;
      }
    }

    .card-author {
      font-size: 15px;
      color: #888;
      margin-bottom: 8px;
      text-align: center;

      // 手机端适配
      @media (max-width: 768px) {
        font-size: 14px;
        margin-bottom: 6px;
      }
    }
  }

  .carousel-dots {
    display: flex;
    justify-content: center;
    margin: 16px 0 0 0;

    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #dedee1;
      margin: 0 4px;

      &.active {
        background: #e67c23;
      }
    }
  }

  .carousel-link {
    color: #1677ff;
    margin-top: 24px;
    cursor: pointer;
    font-size: 16px;
    text-align: center;
  }
}

.book-carousel {
  margin-top: 48px;

  // 手机端适配
  @media (max-width: 768px) {
    margin-top: 32px;
  }

  .carousel-title {
    color: #222;
  }

  .carousel-link {
    color: #1677ff;
  }
}

// 购买按钮样式
.purchase-btn {
  margin-top: 12px;
  width: 120px;

  // 手机端适配
  @media (max-width: 768px) {
    width: 100px;
    font-size: 14px;
    margin-top: 10px;
  }
}

// 弹窗样式
.purchase-dialog {
  .product-info {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;

    // 手机端适配
    @media (max-width: 768px) {
      flex-direction: column;
      text-align: center;
      padding: 12px;
    }

    .dialog-product-img {
      width: 80px;
      height: 80px;
      object-fit: contain;
      margin-right: 16px;
      border-radius: 4px;

      // 手机端适配
      @media (max-width: 768px) {
        margin-right: 0;
        margin-bottom: 12px;
        width: 60px;
        height: 60px;
      }
    }

    .product-details {
      h3 {
        margin: 0 0 8px 0;
        font-size: 16px;
        font-weight: 500;

        // 手机端适配
        @media (max-width: 768px) {
          font-size: 15px;
        }
      }

      .dialog-price {
        margin: 0;
        font-size: 18px;
        color: #e67c23;
        font-weight: bold;

        // 手机端适配
        @media (max-width: 768px) {
          font-size: 16px;
        }
      }
    }
  }

  .order-form {
    margin-top: 20px;
  }
}

.payment-dialog {
  text-align: center;

  .payment-info {
    margin-bottom: 20px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;

    // 手机端适配
    @media (max-width: 768px) {
      padding: 12px;
    }

    h3 {
      margin: 0 0 8px 0;
      font-size: 16px;
      font-weight: 500;

      // 手机端适配
      @media (max-width: 768px) {
        font-size: 15px;
      }
    }

    .payment-price {
      margin: 0;
      font-size: 20px;
      color: #e67c23;
      font-weight: bold;

      // 手机端适配
      @media (max-width: 768px) {
        font-size: 18px;
      }
    }
  }

  .qr-code-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .loading-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 40px 0;

      i {
        font-size: 32px;
        color: #409eff;
        margin-bottom: 16px;
        animation: rotating 2s linear infinite;
      }

      p {
        color: #666;
        font-size: 14px;
        margin: 0;
      }

      @keyframes rotating {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    }

    .qr-code-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .qr-error {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 40px 0;

      p {
        color: #f56c6c;
        font-size: 14px;
        margin: 0;
      }
    }

    .qr-code {
      width: 200px;
      height: 200px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      margin-bottom: 16px;

      // 手机端适配
      @media (max-width: 768px) {
        width: 160px;
        height: 160px;
      }
    }

    .qr-tip {
      color: #666;
      font-size: 14px;
      margin: 0;

      // 手机端适配
      @media (max-width: 768px) {
        font-size: 13px;
      }
    }

    .polling-status {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      margin-top: 16px;
      padding: 8px 16px;
      background: #f0f9ff;
      border: 1px solid #bfdbfe;
      border-radius: 8px;
      color: #3b82f6;
      font-size: 14px;

      i {
        font-size: 16px;
        animation: rotate 1s linear infinite;
      }

      // 手机端适配
      @media (max-width: 768px) {
        font-size: 13px;
        padding: 6px 12px;
        margin-top: 12px;
      }
    }

    // 旋转动画
    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  }
}

// Element Plus 弹窗在移动端的样式覆盖
:deep(.el-dialog) {
  @media (max-width: 768px) {
    margin: 0 !important;
    max-height: 90vh !important;
    border-radius: 12px 12px 0 0 !important;
    position: fixed !important;
    bottom: 0 !important;
    top: auto !important;
    transform: translateX(-50%) !important;
    left: 50% !important;
  }
}

:deep(.el-dialog__header) {
  @media (max-width: 768px) {
    padding: 16px 20px 12px !important;
    text-align: center;
    border-bottom: 1px solid #f0f0f0;
  }
}

:deep(.el-dialog__body) {
  @media (max-width: 768px) {
    padding: 16px 20px !important;
    max-height: calc(80vh - 100px) !important;
    overflow-y: auto !important;
  }
}

:deep(.el-dialog__footer) {
  @media (max-width: 768px) {
    padding: 12px 20px 20px !important;
    text-align: center;
    border-top: 1px solid #f0f0f0;

    .el-button {
      min-width: 80px;
      margin: 0 6px;
    }
  }
}

// 手机端表单样式优化
:deep(.el-form) {
  @media (max-width: 768px) {
    .el-form-item {
      margin-bottom: 16px;

      .el-form-item__label {
        font-size: 14px;
        line-height: 1.5;
        padding-bottom: 4px;
      }

      .el-input__wrapper {
        font-size: 15px;
      }

      .el-textarea__inner {
        font-size: 15px;
        min-height: 80px !important;
      }
    }
  }
}

// 移动端弹窗特殊样式
:deep(.mobile-modal) {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

:deep(.mobile-dialog) {
  @media (max-width: 768px) {
    animation: slideUpFromBottom 0.3s ease-out !important;
  }
}

@keyframes slideUpFromBottom {
  from {
    transform: translateX(-50%) translateY(100%) !important;
    opacity: 0;
  }
  to {
    transform: translateX(-50%) translateY(0) !important;
    opacity: 1;
  }
}

// 移动端输入框和按钮优化
:deep(.el-input__wrapper) {
  @media (max-width: 768px) {
    min-height: 44px !important;
  }
}

:deep(.el-button) {
  @media (max-width: 768px) {
    min-height: 44px !important;
    padding: 10px 20px !important;
    font-size: 16px !important;
  }
}

/* 浮动订单按钮样式 */
.floating-order-btn {
  position: fixed;
  right: 20px;
  top: 14%;
  transform: translateY(-50%);
  z-index: 1000;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 500px;
  padding: 20px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-50%) translateX(-5px);
    box-shadow: 0 6px 25px rgba(102, 126, 234, 0.6);
    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  }

  @media (max-width: 768px) {
    right: 15px;
    padding: 12px 16px;
    font-size: 12px;
    top: 4%;
    i {
      margin-right: 6px;
      font-size: 14px;
    }
  }
}

/* 浮动购物车按钮样式 */
.floating-cart-btn2 {
  position: fixed;
  right: 20px;
  top: 70%;
  transform: translateY(-50%);
  z-index: 1000;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  border: none;
  border-radius: 500px;
  padding: 20px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 20px rgba(255, 107, 107, 0.4);
  transition: all 0.3s ease;
  cursor: pointer;
}

.floating-cart-btn {
  right: 20px;
  top: 20%;
  transform: translateY(-50%);
  z-index: 1000;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  border: none;
  border-radius: 500px;
  padding: 20px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 20px rgba(255, 107, 107, 0.4);
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;

  &:hover {
    transform: translateY(-50%) translateX(-5px);
    box-shadow: 0 6px 25px rgba(255, 107, 107, 0.6);
    background: linear-gradient(135deg, #ee5a52 0%, #ff6b6b 100%);
  }

  .cart-badge {
    position: absolute;
    top: -8px;
    right: -8px;
    background: #fff;
    color: #ff6b6b;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    right: 15px;
    padding: 12px 16px;
    font-size: 12px;
    top: 10%;

    .cart-badge {
      width: 20px;
      height: 20px;
      font-size: 10px;
      top: -6px;
      right: -6px;
    }
  }
}

/* 订单列表弹窗样式 */
.order-list-dialog {
  max-height: 600px;
  overflow-y: auto;

  .empty-orders {
    text-align: center;
    padding: 60px 20px;
    color: #999;

    i {
      font-size: 64px;
      margin-bottom: 16px;
      display: block;
    }

    p {
      font-size: 16px;
      margin: 0;
    }
  }

  .order-list {
    .order-item {
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      margin-bottom: 16px;
      overflow: hidden;
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        border-color: #c6e2ff;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .order-header {
      background: #f8f9fa;
      padding: 12px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #e4e7ed;

      .order-number {
        font-size: 14px;
        color: #666;
        font-weight: 500;
      }

      .order-status {
        padding: 4px 12px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 500;

        &.status-paid {
          background: #e7f7ff;
          color: #1890ff;
        }

        &.status-pending {
          background: #fff7e6;
          color: #fa8c16;
        }

        &.status-shipped {
          background: #f6ffed;
          color: #52c41a;
        }

        &.status-completed {
          background: #f0f9ff;
          color: #1677ff;
        }

        &.status-cancelled {
          background: #fff2f0;
          color: #ff4d4f;
        }
      }
    }

    .order-content {
      padding: 16px;

      .product-info {
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        .product-img {
          width: 60px;
          height: 60px;
          object-fit: cover;
          border-radius: 6px;
          margin-right: 12px;
          border: 1px solid #f0f0f0;
        }

        .product-details {
          flex: 1;

          h4 {
            margin: 0 0 8px 0;
            font-size: 16px;
            color: #333;
            font-weight: 500;
          }

          .price {
            margin: 0;
            font-size: 18px;
            color: #ff4d4f;
            font-weight: 600;
          }
        }
      }

      .order-details {
        background: #fafafa;
        padding: 12px;
        border-radius: 6px;

        .detail-row {
          display: flex;
          margin-bottom: 8px;
          font-size: 14px;

          &:last-child {
            margin-bottom: 0;
          }

          .label {
            color: #666;
            width: 80px;
            flex-shrink: 0;
          }

          .value {
            color: #333;
            flex: 1;
          }
        }
      }
    }

    .order-actions {
      padding: 12px 16px;
      border-top: 1px solid #f0f0f0;
      text-align: right;

      .el-button {
        margin-left: 8px;

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .order-list .order-item {
      .order-header {
        padding: 10px 12px;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
      }

      .order-content {
        padding: 12px;

        .product-info {
          .product-img {
            width: 50px;
            height: 50px;
          }

          .product-details h4 {
            font-size: 14px;
          }

          .price {
            font-size: 16px;
          }
        }

        .order-details .detail-row {
          flex-direction: column;
          gap: 4px;

          .label {
            width: auto;
            font-weight: 500;
          }
        }
      }

      .order-actions {
        padding: 10px 12px;

        .el-button {
          margin: 0 4px 8px 0;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}

/* 购物车弹窗样式 */
.cart-dialog {
  .empty-cart {
    text-align: center;
    padding: 60px 20px;
    color: #999;

    i {
      font-size: 64px;
      margin-bottom: 16px;
      display: block;
      color: #ddd;
    }

    p {
      font-size: 16px;
      margin: 8px 0;
    }

    .empty-tip {
      font-size: 14px;
      color: #bbb;
    }
  }

  .cart-items {
    max-height: 400px;
    overflow-y: auto;

    .cart-item {
      display: flex;
      align-items: center;
      padding: 16px 0;
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }

      .cart-item-img {
        width: 60px;
        height: 60px;
        object-fit: cover;
        border-radius: 6px;
        margin-right: 16px;
        border: 1px solid #f0f0f0;
      }

      .cart-item-details {
        flex: 1;

        h4 {
          margin: 0 0 8px 0;
          font-size: 16px;
          color: #333;
          font-weight: 500;
        }

        .cart-item-price {
          margin: 0 0 12px 0;
          font-size: 16px;
          color: #ff4d4f;
          font-weight: 600;
        }

        .quantity-controls {
          display: flex;
          align-items: center;
          gap: 8px;

          .quantity {
            min-width: 30px;
            text-align: center;
            font-weight: 500;
          }

          .el-button {
            width: 28px;
            height: 28px;
            padding: 0;
          }
        }
      }
    }

    .cart-summary {
      padding: 20px 0;
      border-top: 2px solid #f0f0f0;
      margin-top: 16px;

      .total-price {
        text-align: right;
        font-size: 18px;
        font-weight: 600;
        color: #333;

        .price-amount {
          color: #ff4d4f;
          font-size: 20px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .cart-items .cart-item {
      padding: 12px 0;

      .cart-item-img {
        width: 50px;
        height: 50px;
        margin-right: 12px;
      }

      .cart-item-details {
        h4 {
          font-size: 14px;
        }

        .cart-item-price {
          font-size: 14px;
        }

        .quantity-controls {
          gap: 6px;

          .el-button {
            width: 24px;
            height: 24px;
            font-size: 12px;
          }

          .quantity {
            min-width: 24px;
            font-size: 14px;
          }
        }
      }
    }

    .cart-summary .total-price {
      font-size: 16px;

      .price-amount {
        font-size: 18px;
      }
    }
  }
}

.cart-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  @media (max-width: 768px) {
    justify-content: center;
    flex-wrap: wrap;

    .el-button {
      flex: 1;
      min-width: 100px;
    }
  }
}
</style>
